import React from 'react';

import './Footer.scss';

type FooterComponentProps = {
  children: JSX.Element;
};

function Footer({ children }: FooterComponentProps) {
  return <div className={'footer'}>{children}</div>;
}

export default Footer;
